var map = {
	"./1.svg": "d288",
	"./2.svg": "e8d2",
	"./3.svg": "0e25",
	"./4.svg": "b681",
	"./5.svg": "15dd",
	"./8.svg": "2db1",
	"./9.svg": "4386"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1188";